import { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HomeShowcase from '../components/HomeShowcase';
// Import the new component
import EnquirySection from '../components/EnquirySection'; 

interface HomePageProps {
  mode: 'light' | 'dark';
  setMode: (mode: 'light' | 'dark') => void;
}

const HomePage = ({ mode, setMode }: HomePageProps) => {
  const [isLoggedIn, setLoggedin] = useState<boolean>(false);

  return (
    <>
      {/* <Header /> (Assuming you might add this back later) */}
      
      <HomeShowcase />

      {/* ------------------------------------------------ */}
      {/* REUSABLE ENQUIRY SECTION COMPONENT          */}
      {/* ------------------------------------------------ */}
      <EnquirySection />

      <Footer />
    </>
  );
};

export default HomePage;